import React from 'react';

import { Box, Card, Heading } from '@betterment/samba-react';
import { CardLoader, SambaAutoLink, useFeatureFlag } from '@betterment/shared-components';

import {
  ProductOnboardingCrossSellItem,
  ProductOnboardingCrossSellItemEnvelopesEnabled,
} from './ProductOnboardingCrossSellItem';

import { trackClick } from '../../features/track';
import { ProductCategoryOptionsOrder } from '../../graphql/schema';
import { useColorMode } from '../../Shared/components-v2/color-mode/color-mode-state';
import { urlBuilder } from '../../Shared/urlBuilder';
import { useProductOnboardingOptions } from '../hooks/useProductOnboardingOptions';

export const ProductOnboardingCrossSellCard: React.FC = () => {
  const { data } = useProductOnboardingOptions(ProductCategoryOptionsOrder.CrossSell);
  const { colorMode } = useColorMode();
  const { enabled: isEnvelopesEnabled } = useFeatureFlag({
    splitName: 'retail.envelopes_experience_q1_2025_enabled',
    context: 'ProductOnboardingCrossSellCard',
  });

  if (!data) return <CardLoader />;

  if (!data.crossSellOptions.length) return null;

  const options = data.crossSellOptions.slice(0, 4);

  const flexDirection = ['column', 'column', 'column', 'column', 'row'];

  return (
    <Card data-testid="specPageProductCrossSellCard">
      <Card.Header css={{ paddingX: 'space.300', paddingTop: 'space.300' }}>
        <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
          <Heading as="h2" color="text" variant="title200">
            {isEnvelopesEnabled ? 'Explore more' : 'Explore more products'}
          </Heading>
          <SambaAutoLink
            to={urlBuilder.addGoal.absolute()}
            onClick={() => trackClick({ name: 'explore_more_products_see_all' })}
          >
            See all
          </SambaAutoLink>
        </Box>
      </Card.Header>
      <Box css={{ padding: 'space.300', display: 'flex', flexDirection, gap: 'space.100' }}>
        {[options.slice(0, 2), options.slice(2, 4)].map((optionsRow, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box css={{ flex: 1, display: 'flex', gap: 'space.100' }} key={`cross-sell-card-chunk-${i}`}>
            {optionsRow.map(o =>
              isEnvelopesEnabled ? (
                <ProductOnboardingCrossSellItemEnvelopesEnabled
                  key={o.id}
                  id={o.id}
                  name={o.name}
                  description={o.yieldDescription || ''}
                  imageUrl={o.image[colorMode]}
                  legacyProductCategory={o.legacyProductCategory}
                />
              ) : (
                <ProductOnboardingCrossSellItem
                  key={o.id}
                  name={o.name}
                  description={o.yieldDescription || o.shortDescription}
                  imageUrl={o.image[colorMode]}
                  legacyProductCategory={o.legacyProductCategory}
                />
              )
            )}
          </Box>
        ))}
      </Box>
    </Card>
  );
};
